var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#9D9D9D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6159 26.923H20.2546V21.1945L22.4943 23.5315L23.6414 22.3345L19.3806 18.0025L15.1745 22.3915L16.3216 23.5885L18.6159 21.1945V26.923ZM12.2794 30.4C11.8424 30.4 11.46 30.229 11.1322 29.887C10.8045 29.545 10.6406 29.146 10.6406 28.69V9.31C10.6406 8.854 10.8045 8.455 11.1322 8.113C11.46 7.771 11.8424 7.6 12.2794 7.6H22.1392L28.1206 13.8415V28.69C28.1206 29.146 27.9567 29.545 27.629 29.887C27.3012 30.229 26.9189 30.4 26.4819 30.4H12.2794ZM21.3198 14.611V9.31H12.2794V28.69H26.4819V14.611H21.3198ZM12.2794 9.31V14.611V9.31V28.69V9.31Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.7a8702226136f3bc31645e5e8de34f85.svg";
export { ForwardRef as ReactComponent };